import { useRouter } from "next/router";
import React from "react";
import BlogCard from "../BlogCard";
import classes from "./styles.module.scss";

const BlogList = ({ blogs, title }) => {
  const router = useRouter();
  return (
    <div className={classes.container}>
      {title && <div className={classes.title}>{title}</div>}
      <div className={classes.blogList}>
        {blogs?.length > 0 &&
          blogs.map((item, index) => {
            return <BlogCard key={index} blog={item} />;
          })}
      </div>
    </div>
  );
};

export default BlogList;
